import { alpha, Box, Paper, styled } from '@mui/material';
import { m } from 'framer-motion';
export const SwiperPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'full_height',
})(({ theme, full_height = false }) => ({
    textAlign: 'center',
    backgroundColor: full_height ? 'transparent' : theme.palette.background.paper,
    boxShadow: 'none',
    height: '90%',
    borderRadius: '21px',
    display: 'flex',
    padding: 12,
    paddingTop: 0,
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
}));
export const PaperSlide = styled(m.div)({
    height: '100%',
    width: '100%',
});
export const SwiperContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'full_height',
})(({ theme, full_height = false }) => ({
    position: 'absolute',
    top: full_height ? '55%' : '0',
    left: '50%',
    transform: `translate(-50%, ${full_height ? '-50' : '0'}%)`,
    height: full_height ? '90%' : '100%',
    maxHeight: 600,
    width: '100%',
    overflow: 'hidden',
    userSelect: 'none',
    '& .swiper': {
        height: '100%',
        width: '100%',
        userSelect: 'none',
    },
    '& .swiper-pagination-bullets': {
        bottom: '3%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: alpha(theme.palette.background.default, 0.2),
    },
    '& .swiper-pagination-lock': {
        display: 'block',
    },
    '& .swiper-button-lock': {
        display: 'flex',
    },
    '& .swiper-button-prev, .swiper-button-next': {
        color: theme.palette.heat.main,
        top: 0,
        width: '10%',
        height: '100%',
        position: 'absolute',
    },
    '& .swiper-button-prev': {
        left: 0,
    },
    '& .swiper-button-next': {
        right: 0,
    },
    '& .swiper-pagination-bullet': {
        backgroundColor: theme.palette.heat.main,
    },
    '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.heat.main,
    },
}));
